import React, { useState, useEffect } from 'react';
import { getWeightParams, hasAnyWeight } from '../utils/recommendationEngine';
import ProductCard from './ProductCard';
import { useBreakpoint } from '../hooks/useBreakpoint';
import api from '../api/axios';

export default function RecommendedProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [personalized, setPersonalized] = useState(false);
  const { isMobile } = useBreakpoint();

  useEffect(() => {
    const hasBehavior = hasAnyWeight();
    setPersonalized(hasBehavior);

    const params = getWeightParams();
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).map(([k, v]) => [k, String(v)]))
    );
    qs.set('limit', '8');

    api.get(`/products/recommendations/?${qs.toString()}`)
      .then(res => setProducts(res.data.results || res.data || []))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <section style={{ padding: isMobile ? '40px 16px' : '60px 24px', maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ textAlign: 'center', color: '#888', fontSize: 15 }}>Finding your picks…</div>
    </section>
  );

  if (!products.length) return null;

  return (
    <section style={{ padding: isMobile ? '40px 16px' : '60px 24px', maxWidth: 1200, margin: '0 auto' }}>
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: isMobile ? 24 : 32, color: '#2C2C2C', textAlign: 'center', marginBottom: 8 }}>
        {personalized ? 'Just for You' : 'You May Also Like'}
      </h2>
      <p style={{ textAlign: 'center', color: '#888', marginBottom: isMobile ? 24 : 40, fontSize: 15 }}>
        {personalized ? 'Personalised picks based on your browsing' : 'Handpicked favourites to explore'}
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(240px, 1fr))', gap: isMobile ? 12 : 24 }}>
        {products.map(p => <ProductCard key={p.id} product={p} />)}
      </div>
    </section>
  );
}
